(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mohseven-product-bundle"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const escapeHtml = value => String(value || '').replace(/[&<>"']/g, char => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[char]));

    const init = root => {
      if (!root || root.dataset.ready === '1') return;
      root.dataset.ready = '1';

      const device = root.dataset.device;
      const deviceLabel = root.dataset.deviceLabel;
      const currentProductId = String(root.dataset.currentProductId);
      const currentType = root.dataset.currentProductType;
      const initialVariantId = String(root.dataset.currentVariantId);
      const itemsHost = root.querySelector('[data-bundle-items]');
      const loading = root.querySelector('[data-bundle-loading]');
      const summary = root.querySelector('[data-bundle-summary]');
      const normalTotal = root.querySelector('[data-normal-total]');
      const setTotal = root.querySelector('[data-set-total]');
      const addButton = root.querySelector('[data-bundle-add]');
      const note = root.querySelector('[data-bundle-note]');
      const error = root.querySelector('[data-bundle-error]');
      const currency = window.Shopify?.currency?.active || 'TRY';
      const money = new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency,
        maximumFractionDigits: 2
      });
      const labels = {
        screen: root.dataset.labelScreen,
        camera: root.dataset.labelCamera,
        case: root.dataset.labelCase,
        chooseProduct: root.dataset.labelChooseProduct,
        chooseVariant: root.dataset.labelChooseVariant,
        include: root.dataset.labelInclude,
        add: root.dataset.labelAdd,
        adding: root.dataset.labelAdding,
        empty: root.dataset.labelEmpty
      };

      let catalog = [];
      let baseProduct = null;
      const selections = new Map();

      const tagList = product => Array.isArray(product.tags)
        ? product.tags
        : String(product.tags || '').split(',').map(tag => tag.trim()).filter(Boolean);

      const productDevice = product => {
        const found = tagList(product).find(tag => tag.indexOf('device:') === 0);
        return found ? found.slice(7) : '';
      };

      const availableVariants = product => (product.variants || []).filter(variant => variant.available);
      const isAvailable = product => availableVariants(product).length > 0;

      const score = (product, category) => {
        const title = String(product.title || '').toLocaleLowerCase('tr-TR');
        const tags = tagList(product).join(' ').toLocaleLowerCase('tr-TR');
        let value = 0;
        if (tags.includes('feature:sapphire')) value += 12;
        if (tags.includes('feature:magsafe')) value += 9;
        if (tags.includes('feature:privacy')) value += 6;
        if (tags.includes('feature:clear-hd')) value += 5;
        if (title.includes('m7')) value += 8;
        if (title.includes('alüminyum')) value += 7;
        if (title.includes('safir')) value += 5;
        if (category === 'case' && title.includes('aramid')) value += 4;
        return value;
      };

      const shortTitle = product => {
        let title = String(product.title || '');
        title = title.replace(deviceLabel, '').trim();
        title = title.replace(/^Mohseven\s*/i, '').trim();
        return title || product.title;
      };

      const productImage = product => product.image || '';

      const getBaseVariant = () => {
        if (!baseProduct) return null;
        const validIds = new Set((baseProduct.variants || []).map(variant => String(variant.id)));
        const candidates = Array.from(document.querySelectorAll('form[action*="/cart/add"] input[name="id"]'));
        const selectedInput = candidates.find(input => validIds.has(String(input.value)));
        const selectedId = selectedInput ? String(selectedInput.value) : initialVariantId;
        return (baseProduct.variants || []).find(variant => String(variant.id) === selectedId)
          || availableVariants(baseProduct)[0]
          || baseProduct.variants?.[0]
          || null;
      };

      const updateTotals = () => {
        const baseVariant = getBaseVariant();
        if (!baseVariant) return;
        let total = Number(baseVariant.price || 0);
        selections.forEach(selection => {
          if (selection.enabled && selection.variant) total += Number(selection.variant.price || 0);
        });
        normalTotal.textContent = money.format(total);
        setTotal.textContent = money.format(total * 0.98);
      };

      const renderCategory = (category, title, products) => {
        if (!products.length) return null;

        const sorted = products.slice().sort((a, b) => score(b, category) - score(a, category));
        const limited = sorted.slice(0, 8);
        const initialProduct = limited[0];
        const initialVariant = availableVariants(initialProduct)[0];
        if (!initialVariant) return null;

        const row = document.createElement('article');
        row.className = 'moh-product-bundle__item';
        row.dataset.category = category;

        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.checked = true;
        checkbox.className = 'moh-product-bundle__check';
        checkbox.setAttribute('aria-label', labels.include);

        const image = document.createElement('img');
        image.className = 'moh-product-bundle__image';
        image.loading = 'lazy';
        image.alt = '';
        image.src = productImage(initialProduct);

        const copy = document.createElement('div');
        copy.className = 'moh-product-bundle__copy';
        copy.innerHTML =
          '<span class="moh-product-bundle__category">' + escapeHtml(title) + '</span>' +
          '<strong class="moh-product-bundle__name"></strong>' +
          '<span class="moh-product-bundle__price"></span>';

        const controls = document.createElement('div');
        controls.className = 'moh-product-bundle__controls';

        const productLabel = document.createElement('label');
        productLabel.textContent = labels.chooseProduct;
        const productSelect = document.createElement('select');
        limited.forEach(product => {
          const option = document.createElement('option');
          option.value = String(product.id);
          option.textContent = shortTitle(product);
          productSelect.append(option);
        });
        productLabel.append(productSelect);
        controls.append(productLabel);

        const variantLabel = document.createElement('label');
        variantLabel.textContent = labels.chooseVariant;
        const variantSelect = document.createElement('select');
        variantLabel.append(variantSelect);
        controls.append(variantLabel);

        row.append(checkbox, image, copy, controls);
        itemsHost.append(row);

        const nameNode = copy.querySelector('.moh-product-bundle__name');
        const priceNode = copy.querySelector('.moh-product-bundle__price');

        const applyProduct = product => {
          const variants = availableVariants(product);
          const variant = variants[0];
          variantSelect.innerHTML = '';
          variants.forEach(item => {
            const option = document.createElement('option');
            option.value = String(item.id);
            option.textContent = item.title === 'Default Title'
              ? money.format(Number(item.price || 0))
              : item.title + ' · ' + money.format(Number(item.price || 0));
            variantSelect.append(option);
          });
          variantLabel.hidden = variants.length <= 1;
          image.src = productImage(product);
          nameNode.textContent = shortTitle(product);
          priceNode.textContent = variant ? money.format(Number(variant.price || 0)) : '';
          selections.set(category, { product, variant, enabled: checkbox.checked });
          updateTotals();
        };

        productSelect.addEventListener('change', () => {
          const product = limited.find(item => String(item.id) === productSelect.value);
          if (product) applyProduct(product);
        });

        variantSelect.addEventListener('change', () => {
          const selection = selections.get(category);
          if (!selection) return;
          const variant = availableVariants(selection.product).find(item => String(item.id) === variantSelect.value);
          selection.variant = variant || selection.variant;
          priceNode.textContent = selection.variant ? money.format(Number(selection.variant.price || 0)) : '';
          updateTotals();
        });

        checkbox.addEventListener('change', () => {
          const selection = selections.get(category);
          if (selection) selection.enabled = checkbox.checked;
          row.style.opacity = checkbox.checked ? '1' : '.55';
          updateTotals();
        });

        applyProduct(initialProduct);
        return row;
      };

      const boot = products => {
        catalog = products.filter(isAvailable);
        baseProduct = catalog.find(product => String(product.id) === currentProductId) || null;
        const matches = catalog.filter(product =>
          productDevice(product) === device && String(product.id) !== currentProductId
        );

        const groups = [
          {
            key: 'screen',
            title: labels.screen,
            type: 'Ekran Koruyucu'
          },
          {
            key: 'camera',
            title: labels.camera,
            type: 'Kamera Lens Koruyucu'
          },
          {
            key: 'case',
            title: labels.case,
            type: 'Telefon Kılıfı'
          }
        ].filter(group => group.type !== currentType);

        loading.hidden = true;
        let rendered = 0;
        groups.forEach(group => {
          const row = renderCategory(group.key, group.title, matches.filter(product => product.product_type === group.type));
          if (row) rendered += 1;
        });

        if (!baseProduct || rendered === 0) {
          itemsHost.innerHTML = '<p>' + escapeHtml(labels.empty) + '</p>';
          return;
        }

        summary.hidden = false;
        addButton.hidden = false;
        note.hidden = false;
        updateTotals();

        document.addEventListener('change', event => {
          if (event.target && event.target.matches('form[action*="/cart/add"] input[name="id"]')) {
            updateTotals();
          }
        });

        addButton.addEventListener('click', async () => {
          error.hidden = true;
          const baseVariant = getBaseVariant();
          if (!baseVariant) return;

          const lines = [{
            id: baseVariant.id,
            quantity: 1,
            properties: {
              '_mohseven_set': 'Tam Koruma Seti',
              'Cihaz': deviceLabel
            }
          }];

          selections.forEach(selection => {
            if (!selection.enabled || !selection.variant) return;
            lines.push({
              id: selection.variant.id,
              quantity: 1,
              properties: {
                '_mohseven_set': 'Tam Koruma Seti',
                'Cihaz': deviceLabel
              }
            });
          });

          addButton.disabled = true;
          addButton.textContent = labels.adding;

          try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({ items: lines })
            });
            if (!response.ok) throw new Error('cart');
            const cartPath = window.Shopify.routes.root + 'cart';
            window.location.assign(
              window.Shopify.routes.root +
              'discount/MOHTAMKORU2?redirect=' +
              encodeURIComponent(cartPath)
            );
          } catch (err) {
            addButton.disabled = false;
            addButton.textContent = labels.add;
            error.hidden = false;
          }
        });
      };

      try {
        const catalogNode = root.parentElement.querySelector('[data-bundle-catalog]') || document.querySelector('[data-bundle-catalog]');
        const products = JSON.parse(catalogNode?.textContent || '[]');
        boot(products);
      } catch (err) {
        loading.textContent = labels.empty;
      }
    };

    const initAll = container => {
      (container || document).querySelectorAll('[data-moh-product-bundle]').forEach(init);
    };

    initAll(document);
    document.addEventListener('shopify:section:load', event => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mohseven-protection-bundle"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-moh-bundle]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  const stage = root.querySelector('[data-stage]');
  const progress = root.querySelector('[data-progress]');
  const money = new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', maximumFractionDigits: 2 });
  let catalog = [], state = { brand: null, device: null, screen: null, camera: null, lensColor: null, band: null };
  const copy = value => String(value || '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const deviceTag = product => String(product.tags || '').split(',').map(tag => tag.trim()).find(tag => tag.indexOf('device:') === 0)?.slice(7);
  const feature = (product, name) => String(product.tags || '').indexOf('feature:' + name) !== -1;
  const available = product => (product.variants || []).some(variant => variant.available);
  const firstAvailable = (product, preferredColor) => {
    const variants = (product.variants || []).filter(variant => variant.available);
    if (preferredColor) return variants.find(variant => String(variant.title).toLocaleLowerCase('tr-TR') === preferredColor.toLocaleLowerCase('tr-TR')) || variants[0];
    return variants[0];
  };
  const title = device => ({
    'iphone-18-pro-max':'iPhone 18 Pro Max','iphone-18-pro':'iPhone 18 Pro','iphone-17-pro-max':'iPhone 17 Pro Max','iphone-17-pro':'iPhone 17 Pro','iphone-17-air':'iPhone 17 Air','iphone-17':'iPhone 17','iphone-16-pro-max':'iPhone 16 Pro Max','iphone-16-pro':'iPhone 16 Pro','iphone-16-plus':'iPhone 16 Plus','iphone-16':'iPhone 16','iphone-16e':'iPhone 16e','iphone-15-pro-max':'iPhone 15 Pro Max','iphone-15-pro':'iPhone 15 Pro','iphone-15-plus':'iPhone 15 Plus','iphone-15':'iPhone 15','iphone-14-pro-max':'iPhone 14 Pro Max','iphone-14-pro':'iPhone 14 Pro','iphone-14':'iPhone 14','iphone-13-pro':'iPhone 13 Pro','iphone-13':'iPhone 13','galaxy-s26-ultra':'Galaxy S26 Ultra','galaxy-s25-ultra':'Galaxy S25 Ultra','galaxy-s24-ultra':'Galaxy S24 Ultra','galaxy-z-fold-8':'Galaxy Z Fold 8','galaxy-z-fold-7':'Galaxy Z Fold 7','galaxy-z-flip-8':'Galaxy Z Flip 8','galaxy-z-flip-7':'Galaxy Z Flip 7','apple-watch-ultra-49mm':'Apple Watch Ultra 49mm','apple-watch-10-46mm':'Apple Watch 10-11-12 46mm','apple-watch-7-45mm':'Apple Watch 7 45mm','apple-watch-44mm':'Apple Watch 44mm','apple-watch-42mm':'Apple Watch 42mm'
  }[device] || device);
  const groups = device => {
    const products = catalog.filter(product => deviceTag(product) === device && available(product));
    const screen = products.filter(product => product.product_type === 'Ekran Koruyucu' && !/pure\s+(safir|sapphire)/i.test(String(product.title || '')));
    const lenses = products.filter(product => product.product_type === 'Kamera Lens Koruyucu');
    const cases = products.filter(product => product.product_type === 'Telefon Kılıfı');
    const bands = products.filter(product => product.product_type === 'Akıllı Saat Kordonu');
    const best = list => list.slice().sort((a, b) => (feature(b,'sapphire') - feature(a,'sapphire')) || (b.title.includes('Alüminyum') - a.title.includes('Alüminyum')))[0];
    const aluminum = best(lenses.filter(product => product.title.includes('Alüminyum') && !product.title.includes('Tekli')));
    const single = best(lenses.filter(product => product.title.includes('Tekli')));
    const pet = best(lenses.filter(product => feature(product, 'pet-film') || product.title.includes('Pet Film')));
    return { screen, clear: best(screen.filter(product => feature(product, 'clear-hd'))), privacy: best(screen.filter(product => feature(product, 'privacy'))), aluminum, single, pet, case: best(cases), bands };
  };
  const eligible = device => { const g = groups(device); return (g.screen.length && (g.aluminum || g.single || g.case)) || (g.bands.length && g.screen.length); };
  const devicesFor = brand => [...new Set(catalog.map(deviceTag).filter(Boolean).filter(device => { if (!eligible(device)) return false; if (brand === 'watch') return device.indexOf('apple-watch-') === 0; if (brand === 'apple') return device.indexOf('iphone-') === 0; return device.indexOf('galaxy-') === 0; }))];
  const step = (index, eyebrow, heading, body) => { progress.innerHTML = [0,1,2,3].map(n => '<i class="' + (n <= index ? 'on' : '') + '"></i>').join(''); stage.innerHTML = '<div class="moh-bundle__step"><small>' + copy(eyebrow) + '</small><h2>' + copy(heading) + '</h2>' + (body || '') + '</div>'; };
  const choices = (items, onSelect) => { const box = document.createElement('div'); box.className = 'moh-bundle__choices'; items.forEach(item => { const button = document.createElement('button'); button.type = 'button'; button.className = 'moh-bundle__choice'; button.innerHTML = '<strong>' + copy(item.label) + '</strong>' + (item.note ? '<span>' + copy(item.note) + '</span>' : ''); button.addEventListener('click', () => onSelect(item.value)); box.append(button); }); stage.querySelector('.moh-bundle__step').append(box); };
  const back = action => { const button = document.createElement('button'); button.type = 'button'; button.className = 'moh-bundle__back'; button.textContent = '← Geri dön'; button.addEventListener('click', action); stage.querySelector('.moh-bundle__step').append(button); };
  const chooseBrand = () => { state = { brand:null, device:null, screen:null, camera:null, lensColor:null, band:null }; step(0,'1. ADIM','Hangi cihazı koruyoruz?'); choices([{label:'Apple iPhone',note:'iPhone modelini seç',value:'apple'},{label:'Samsung Galaxy',note:'Galaxy modelini seç',value:'samsung'},{label:'Apple Watch',note:'Saatini seç',value:'watch'}], value => { state.brand=value; chooseDevice(); }); };
  const chooseDevice = () => { const devices = devicesFor(state.brand); step(1,'2. ADIM','Modelini seç',devices.length ? '': '<p>Bu cihaz için şu anda tamamlayıcı set bulunmuyor.</p>'); choices(devices.map(device => ({label:title(device),note:'Uyumlu setleri gör',value:device})), value => { state.device=value; const g=groups(value); if (state.brand === 'watch') chooseBand(g); else chooseScreen(g); }); back(chooseBrand); };
  const chooseScreen = g => { const options=[]; if(g.privacy) options.push({label:'Hayalet ekran koruyucu',note:'Kalabalıkta ekran gizliliği',value:'privacy'}); if(g.clear) options.push({label:'Şeffaf HD ekran koruyucu',note:'Net görüntü ve günlük koruma',value:'clear'}); step(2,'3. ADIM','Ekran tercihin ne?', 'Aynı sette iki farklı ekran koruyucu olmaz.'); choices(options, value => { state.screen=value; chooseCamera(g); }); back(chooseDevice); };
  const chooseCamera = g => { const options=[]; if(g.aluminum) options.push({label:'Alüminyum kamera koruyucu',note:'Lensleri tek parçada korur',value:'aluminum'}); if(g.single && g.pet) options.push({label:'Tek tek lens + PET kamera koruyucu',note:'Lens ve kamera çerçevesi birlikte korunur',value:'single-pet'}); else if(g.single) options.push({label:'Tek tek kamera lens koruyucu',note:'Her lens için ayrı koruma',value:'single'}); if (!options.length) return showSet(g); step(3,'4. ADIM','Kamera koruma tercihin ne?', 'PET kamera koruyucu yalnızca tek tek lens koruyucuyla birlikte önerilir.'); choices(options, value => { state.camera=value; chooseLensColor(g, value === 'aluminum' ? g.aluminum : g.single); }); back(() => chooseScreen(g)); };
  const chooseLensColor = (g, camera) => { const colors = [...new Set((camera?.variants || []).filter(variant => variant.available).map(variant => variant.title).filter(color => color && color !== 'Default Title'))]; if (!colors.length) return showSet(g); step(3,'5. ADIM','Telefonun hangi renkte?', 'Kamera koruyucusunu cihazına en yakın renk ile eşleştirelim.'); choices(colors.map(color => ({label:color,note:'Uyumlu lens rengi',value:color})), value => { state.lensColor=value; showSet(g); }); back(() => chooseCamera(g)); };
  const chooseBand = g => { step(2,'3. ADIM','Kordon tarzını seç', 'Ekran koruyucusu ve seçtiğin kordon tam sete eklenecek.'); choices(g.bands.map(product => ({label:product.title.replace(/^Apple Watch[^M]*Mohseven /,'Mohseven '),note:'Tam koruma setine ekle',value:product.id})), value => { state.band=value; showSet(g); }); back(chooseDevice); };
  const showSet = g => { let products=[]; let label='Tam Koruma Seti'; const camera = state.camera === 'aluminum' ? g.aluminum : g.single; if (state.brand === 'watch') { const band=g.bands.find(product => product.id === state.band); products=[g.screen[0],band].filter(Boolean); label='Apple Watch Tam Koruma Seti'; } else { products=[state.screen === 'privacy' ? g.privacy : g.clear,camera,state.camera === 'single-pet' ? g.pet : null,g.case].filter(Boolean); label=(state.screen === 'privacy' ? 'Hayalet Camlı ' : 'Şeffaf Camlı ') + 'Tam Koruma Seti'; } const lines=products.map(product => ({product, variant:firstAvailable(product, product === camera ? state.lensColor : null)})).filter(line => line.variant); const total=lines.reduce((sum,line) => sum + Number(line.variant.price),0); const discounted=total*.98; step(3,'SETİN HAZIR',label); const card=document.createElement('div'); card.className='moh-bundle__sets'; card.innerHTML='<article class="moh-bundle__set"><h3>' + copy(title(state.device)) + '</h3><ul>' + lines.map(line => '<li>' + copy(line.product.title) + (line.variant.title && line.variant.title !== 'Default Title' ? ' · ' + copy(line.variant.title) : '') + '</li>').join('') + '</ul><div class="moh-bundle__price"><del>' + money.format(total) + '</del><b>' + money.format(discounted) + '</b><em>%2 set avantajı</em></div><button type="button" class="moh-bundle__buy">Seti sepete ekle</button></article>'; card.querySelector('button').addEventListener('click', async button => { button.disabled=true; button.textContent='Sepete ekleniyor…'; try { const items=lines.map(line => ({id:line.variant.id,quantity:1,properties:{'_mohseven_set':'Tam Koruma Seti','Cihaz':title(state.device)}})); const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})}); if(!response.ok) throw new Error(); window.location.assign('/discount/MOHTAMKORU2?redirect=/cart'); } catch(error) { button.disabled=false; button.textContent='Tekrar dene'; } }); stage.querySelector('.moh-bundle__step').append(card); back(() => state.brand === 'watch' ? chooseBand(g) : chooseLensColor(g, camera)); };
  fetch('/products.json?limit=250').then(response => response.json()).then(data => { catalog=(data.products || []).filter(available); chooseBrand(); }).catch(() => { stage.innerHTML='<p class="moh-bundle__loading">Setler şu an yüklenemedi. Lütfen sayfayı yenileyin.</p>'; });
})();

  } catch(e) { console.error(e); }
})();
})();
